import {CommunicationDto} from './communicationDto';
import {CustomerDto} from '../../customers/data/customerDto';
import {UserDto} from '../../user/data/userDto';

export class FullCommunicationDto {
  communicationDto: CommunicationDto;
  customerDto: CustomerDto;
  creatorDto: UserDto;
  modifierDto: UserDto;
  selected?: boolean;
}
